import algoliasearch from "algoliasearch/lite";

export const searchClient = algoliasearch(
	"10400KT4QR",
	"b31b8750f6e12ab7a051e9aec2336831",
);
